import { createAction, props } from '@ngrx/store';

import { IGenericError, ErrorResponse, IGenericPayload } from 'src/app/core/models/generic-models';
import {
  IsUserDeceasedRequest,
  IsUserDeceasedResponse,
  IUserDeceasedUpdateResponse,
  IUserDeceasedUpdateRequest
} from '../models/deceased.model';

//Check if user is deceased/alive
export const checkIfUserDeceasedRequest = createAction('[Deceased] Load Deceased request', props<{ request: IsUserDeceasedRequest }>());

export const checkIfUserDeceasedResponse = createAction('[Deceased] Load Deceased Success', props<{ response: IsUserDeceasedResponse }>());

export const checkIfUserDeceasedFailure = createAction(
  '[Deceased] Load Deceased Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

//Update if user is deceased -----------------------------
export const updateUserDeceasedRequest = createAction(
  '[Deceased] Load Update Deceased request',
  props<{ request: IUserDeceasedUpdateRequest }>()
);

export const updateUserDeceasedResponse = createAction(
  '[Deceased] Load Update Deceased Success',
  props<{ response: IUserDeceasedUpdateResponse }>()
);

export const updateUserDeceasedFailure = createAction(
  '[Deceased] Load Update Deceased Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

//Update if user is Alive -----------------------------
export const updateUserAliveRequest = createAction(
  '[Deceased] Load Update Alive request',
  props<{ request: IUserDeceasedUpdateRequest }>()
);

export const updateUserAliveResponse = createAction(
  '[Deceased] Load Update Alive Success',
  props<{ response: IUserDeceasedUpdateResponse }>()
);

export const updateUserAliveFailure = createAction(
  '[Deceased] Load Update Alive Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
